import { render } from "./TermsOfUseEs.vue?vue&type=template&id=487acf86&scoped=true"
import script from "./TermsOfUseEs.vue?vue&type=script&lang=js"
export * from "./TermsOfUseEs.vue?vue&type=script&lang=js"

import "./TermsOfUseEs.vue?vue&type=style&index=0&id=487acf86&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-487acf86"]])

export default __exports__